import React from 'react';
import { Calendar, BarChart3 } from 'lucide-react';
import { ViewToggleProps } from '../../types';

/**
 * ViewToggle - Tab switcher between Week View and Season Overview
 */
const ViewToggle: React.FC<ViewToggleProps> = ({
  activeView,
  onViewChange
}) => {
  const tabs = [
    {
      id: 'week' as const,
      label: 'Week View',
      icon: Calendar,
      description: 'Weekly roster snapshot with start/sit analysis'
    },
    {
      id: 'season' as const,
      label: 'Season Overview',
      icon: BarChart3,
      description: 'Draft summary and roster evolution timeline'
    }
  ];

  return (
    <div className="flex items-center space-x-1 bg-background-secondary p-1 rounded-lg border border-fieldline">
      {tabs.map(({ id, label, icon: Icon, description }) => (
        <button
          key={id}
          onClick={() => onViewChange(id)}
          className={`px-4 py-2 rounded-md flex items-center space-x-2 transition-all duration-200 ${
            activeView === id
              ? 'bg-accent-primary/15 text-accent-primary border-b-2 border-accent-primary'
              : 'text-text-secondary hover:text-text-primary hover:bg-background-hover'
          }`}
          title={description}
        >
          <Icon className="w-4 h-4" />
          <span className="font-medium">{label}</span>
        </button>
      ))}
    </div>
  );
};

export default ViewToggle;
